module.exports = __webpack_public_path__ + "img/industry4.545b3f4.jpg";